import { AdComposedPlayer, AdPlaybackPolicy, Player, Promo } from '@quickplay/player-interface';
import { Logger, Error, AsyncUtil } from '@quickplay/foundation';
import { BrightcoveManager } from '../BrightcoveManager';
import { createDefaultBrightcoveAdsPlayer } from './BrightcovePlayer';
import { BrightCoveMetaData } from '../model/BrightCoveMetadata';
import { BrightcoveDataCollectionConfig } from '../model/BrightcoveDataCollectionConfig';
import { createDocumentRetrievalFailure, fetchVmapDocument } from './BrightcovePlayerUtil';
import { getAdCuePointsData } from './VMAPParser';

export const DefaultBrightcoveManager: BrightcoveManager = {
  async getBrightCoveMetadata(adVMAPUrl: string, maxRetries?: number): Promise<BrightCoveMetaData | Error> {
    let vmapResponse = undefined;
    try {
      vmapResponse = await AsyncUtil.retryOnNetworkFailure(() => fetchVmapDocument(adVMAPUrl), maxRetries);
    } catch (error) {
      return Promise.reject(createDocumentRetrievalFailure(error as Error));
    }

    try {
      return getAdCuePointsData(vmapResponse);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  createBrightcoveAdsPlayer(
    player: Player,
    logger: Logger,
    adCueMetadata?: Promo[],
    adPlaybackPolicy?: AdPlaybackPolicy,
    dataCollectionConfig?: BrightcoveDataCollectionConfig,
  ): AdComposedPlayer {
    if (adCueMetadata && adCueMetadata.length !== 0) {
      return createDefaultBrightcoveAdsPlayer(player, logger, adCueMetadata, adPlaybackPolicy, dataCollectionConfig);
    }
    return createDefaultBrightcoveAdsPlayer(player, logger, [], adPlaybackPolicy, dataCollectionConfig);
  },
};
